module.exports = __webpack_public_path__ + "media/images/cursos-titulos-990fff05f0e89c40256e06bc20f1ef08.png";